import {
  ALLOWED_ADMIN,
  APP_MAP,
  // ALLOWED_OPS,
  domainEnv,
  domainToCountryCodeMap,
  OPS_JAVA_ENDPOINTS,
  OPS_USERS,
  QA_PERSON,
} from '@common/constants';
import {get} from '@core/api/axios';
import {
  SF_CORE_SEEDFLEX_AUTH_CLIENT_ID,
  SF_CORE_SEEDFLEX_AUTH_CLIENT_SECRET,
  SF_CORE_ROUTE,
} from '@core/helpers/constants';
import {AxiosResponse} from 'axios';

interface IData {
  seedflexMId?: string | number;
  businessName?: string;
  limitType?: string;
  smeMaskedId?: string | number;
  initialLoanId?: string | number;
  mpId?: string | number;
}

export const getCountryCodeFromUrl = (): string => {
  if (typeof window === 'undefined') {
    return 'MY'; // Default country code
  }
  const {hostname} = window.location;
  const matchingDomain = Object.keys(domainToCountryCodeMap).find((domain) =>
    hostname.endsWith(domain)
  );

  // Return the country code if a match is found, otherwise default to 'SG'
  return matchingDomain ? domainToCountryCodeMap[matchingDomain] : 'SG';
};

export const searchMerchant = async (payload: IData) => {
  try {
    const response = await get(
      `${SF_CORE_ROUTE}${OPS_JAVA_ENDPOINTS.SEARCH_MERCHANT}?seedflexMId=${payload.seedflexMId}&businessName=${payload.businessName}`,
      {
        headers: {
          SeedflexAuthClientId: SF_CORE_SEEDFLEX_AUTH_CLIENT_ID,
          SeedflexAuthClientSecret: SF_CORE_SEEDFLEX_AUTH_CLIENT_SECRET,
        },
      }
    );
    return response as AxiosResponse;
  } catch (error) {
    return error as AxiosResponse;
  }
};

export const selectSmeMId = async (payload: IData) => {
  try {
    const response = await get(
      `${SF_CORE_ROUTE}${OPS_JAVA_ENDPOINTS.SELECT_SME_MASKED_ID}?seedflexMId=${payload.seedflexMId}`,
      {
        headers: {
          SeedflexAuthClientId: SF_CORE_SEEDFLEX_AUTH_CLIENT_ID,
          SeedflexAuthClientSecret: SF_CORE_SEEDFLEX_AUTH_CLIENT_SECRET,
        },
      }
    );
    return response as AxiosResponse;
  } catch (error) {
    return error as AxiosResponse;
  }
};

export const selectAdvance = async (payload: IData) => {
  try {
    const response = await get(
      `${SF_CORE_ROUTE}${OPS_JAVA_ENDPOINTS.SELECT_ADVANCE_ID}?seedflexMId=${payload.seedflexMId}&mpId=${payload.mpId}`,
      {
        headers: {
          SeedflexAuthClientId: SF_CORE_SEEDFLEX_AUTH_CLIENT_ID,
          SeedflexAuthClientSecret: SF_CORE_SEEDFLEX_AUTH_CLIENT_SECRET,
        },
      }
    );
    return response as AxiosResponse;
  } catch (error) {
    return error as AxiosResponse;
  }
};

export const limitHistory = async (payload: IData) => {
  try {
    const response = await get(
      `${SF_CORE_ROUTE}${OPS_JAVA_ENDPOINTS.LIMIT_HISTORY}?limitType=${payload.limitType}&seedflexMId=${payload.seedflexMId}&smeMaskedId=${payload.smeMaskedId}&initialLoanId=${payload.initialLoanId}&mpId=${payload.mpId}`,
      {
        headers: {
          SeedflexAuthClientId: SF_CORE_SEEDFLEX_AUTH_CLIENT_ID,
          SeedflexAuthClientSecret: SF_CORE_SEEDFLEX_AUTH_CLIENT_SECRET,
        },
      }
    );
    return response as AxiosResponse;
  } catch (error) {
    return error as AxiosResponse;
  }
};

export const getEnvfromUrl = (): string => {
  if (typeof window === 'undefined') {
    return 'QA'; // Default env
  }

  const {hostname} = window.location;
  const matchingDomain = Object.keys(domainEnv).find((domain) =>
    hostname.startsWith(domain)
  );

  // Return the env if a match is found, otherwise default to 'QA'
  return matchingDomain ? domainEnv[matchingDomain] : 'QA';
};

export const getAllowedAdmins = (): string[] => {
  const env = getEnvfromUrl();

  if (env === 'MYSTAGE' || env === 'IDSTAGE' || env === 'THSTAGE') {
    return [...ALLOWED_ADMIN, ...QA_PERSON, ...OPS_USERS];
  }

  if (env === 'MYPROD') {
    return [...ALLOWED_ADMIN, ...OPS_USERS, ...QA_PERSON];
  }

  return [...ALLOWED_ADMIN, ...QA_PERSON];
};

export const getAllowedApplicationDataUsers = (): string[] => {
  const env = getEnvfromUrl();
  const selected = OPS_USERS.slice(3);

  if (env === 'MYPROD') {
    return [...ALLOWED_ADMIN, ...QA_PERSON, OPS_USERS[1], ...selected];
  }

  return [...ALLOWED_ADMIN, ...QA_PERSON];
};

export const getAllowedOps = (): string[] => {
  const env = getEnvfromUrl();

  if (env === 'MYSTAGE' || env === 'IDSTAGE' || env === 'THSTAGE') {
    return [
      ...ALLOWED_ADMIN,
      'trixia.wong@seedflex.com',
      'jegathisnair.murthy@seedflex.com',
      'navina.r@seedflex.com',
      'nova.taner@seedflex.com',
      ...QA_PERSON,
    ];
  }

  if (env === 'MYPROD') {
    return [
      ...ALLOWED_ADMIN,
      ...QA_PERSON,
      'trixia.wong@seedflex.com',
      'jegathisnair.murthy@seedflex.com',
      'navina.r@seedflex.com',
      'afiq.amirul@seedflex.com',
      'khairull.azmi@seedflex.com',
    ];
  }

  if (env === 'IDPROD') {
    return [...ALLOWED_ADMIN, ...QA_PERSON, 'nova.taner@seedflex.com'];
  }

  return [...ALLOWED_ADMIN, ...QA_PERSON];
};

export const selectNonCompletedAdvance = async (payload: IData) => {
  try {
    const response = await get(
      `${SF_CORE_ROUTE}${OPS_JAVA_ENDPOINTS.NONCOMPLETED_ADVANCE}?seedflexMid=${payload.seedflexMId}`,
      {
        headers: {
          SeedflexAuthClientId: SF_CORE_SEEDFLEX_AUTH_CLIENT_ID,
          SeedflexAuthClientSecret: SF_CORE_SEEDFLEX_AUTH_CLIENT_SECRET,
        },
      }
    );
    return response as AxiosResponse;
  } catch (error) {
    return error as AxiosResponse;
  }
};

export const loanDetails = async (payload: IData) => {
  try {
    const response = await get(
      `${SF_CORE_ROUTE}${OPS_JAVA_ENDPOINTS.LOAN_DETAILS}?loanId=${payload.initialLoanId}`,
      {
        headers: {
          SeedflexAuthClientId: SF_CORE_SEEDFLEX_AUTH_CLIENT_ID,
          SeedflexAuthClientSecret: SF_CORE_SEEDFLEX_AUTH_CLIENT_SECRET,
        },
      }
    );
    return response as AxiosResponse;
  } catch (error) {
    return error as AxiosResponse;
  }
};

export const getAllowedOpsCollection = (): string[] => {
  const env = getEnvfromUrl();
  const selected = OPS_USERS.slice(1);

  if (env === 'MYSTAGE' || env === 'IDSTAGE' || env === 'THSTAGE') {
    return [...ALLOWED_ADMIN, ...QA_PERSON, ...selected];
  }

  if (env === 'MYPROD') {
    return [...ALLOWED_ADMIN, ...selected, ...QA_PERSON];
  }

  return [...ALLOWED_ADMIN, ...QA_PERSON];
};

export const getAllowedOpsBlacklist = (): string[] => {
  const env = getEnvfromUrl();

  const blacklistOps = [
    'khairull.azmi@seedflex.com',
    'afiq.amirul@seedflex.com',
  ];

  if (env === 'MYSTAGE') {
    return [
      ALLOWED_ADMIN[0],
      ALLOWED_ADMIN[2],
      ...QA_PERSON,
      ...blacklistOps,
      OPS_USERS[0],
    ];
  }

  if (env === 'MYPROD') {
    return [
      ALLOWED_ADMIN[0],
      ALLOWED_ADMIN[2],
      ...QA_PERSON,
      ...blacklistOps,
      OPS_USERS[0],
    ];
  }

  return [...ALLOWED_ADMIN, ...QA_PERSON];
};

export const getTheme = (): string => {
  if (typeof window === 'undefined') {
    return 'default';
  }

  const {hostname} = window.location;
  const matchingDomain = Object.keys(APP_MAP).find((domain) =>
    hostname.startsWith(domain)
  );

  // Return the domain if a match is found, otherwise default to 'default'
  return matchingDomain ? APP_MAP[matchingDomain] : 'default';
};
